import React from "react";

export function ElephantLogo({ className = "w-10 h-10" }) {
  return (
    <img
      src="/sily-mark.png"
      alt="Sily Agency"
      className={`${className} object-contain`}
      draggable="false"
    />
  );
}
